// src/pages/ManagingStress.js

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function ManagingStress() {
  return (
    <>
      {/* Inline Style for Montserrat if no global CSS */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');

          body, h1, h2, h3, h4, h5, h6, p, .btn, .navbar-brand, .nav-link {
            font-family: 'Montserrat', sans-serif !important;
          }
        `}
      </style>

      {/* ========== HERO BANNER ========== */}
      <div
        style={{
          backgroundColor: '#c8102e',
          color: '#fff',
          padding: '6rem 0',
          textAlign: 'center',
        }}
      >
        <Container>
          <h1 style={{ fontWeight: '700', fontSize: '2.5rem' }}>
            Managing Stress & Anxiety with BFS
          </h1>
          <p style={{ fontSize: '1.1rem', maxWidth: '700px', margin: '1rem auto' }}>
            Discover effective strategies to reduce stress, calm nerves, and cope with BFS-related anxiety.
          </p>
        </Container>
      </div>

      {/* ========== ARTICLE CONTENT ========== */}
      <div style={{ backgroundColor: '#f5f5f5', padding: '4rem 0' }}>
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <h2 style={{ fontWeight: '700', marginBottom: '1.5rem' }}>Why Stress Matters</h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Stress can intensify muscle twitching in people with Benign Fasciculation Syndrome (BFS).
                Heightened anxiety and stress hormones can make the nervous system more reactive, leading to
                more frequent or pronounced fasciculations.
              </p>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Identifying Your Stressors
              </h3>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                <li><strong>Work & Deadlines:</strong> Excessive workload or tight schedules can elevate tension.</li>
                <li><strong>Health Anxieties:</strong> Worries about twitching often feed a cycle of stress.</li>
                <li><strong>Personal Obligations:</strong> Family or financial issues may contribute to chronic stress.</li>
              </ul>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Practical Coping Strategies
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Adopting daily routines to minimize stress can help reduce twitch severity and frequency.
                Consider these ideas:
              </p>
              <ul style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                <li><strong>Mindfulness & Meditation:</strong> Short sessions of focused breathing or guided meditation can lower overall stress.</li>
                <li><strong>Physical Activity:</strong> Gentle exercises (yoga, walking, swimming) help release endorphins and calm the nervous system.</li>
                <li><strong>Healthy Sleep Patterns:</strong> Adequate rest supports muscle recovery and stabilizes mood.</li>
                <li><strong>Limit Caffeine & Stimulants:</strong> Reducing coffee, tea, or energy drinks may lessen twitch reactivity.</li>
              </ul>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Overcoming Anxiety Cycles
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                Anxiety often emerges when we catastrophize twitches or fear an underlying serious condition.
                Educating yourself on BFS, seeking reassurance from medical professionals, and engaging
                in supportive communities can break the cycle of worry. Cognitive Behavioral Therapy (CBT) 
                is also a tool that some individuals find valuable for managing health-related anxieties.
              </p>

              <h3 style={{ fontWeight: '700', marginTop: '2rem', marginBottom: '1rem' }}>
                Reaching Out for Support
              </h3>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                If stress or anxiety feels overwhelming, consider talking to a mental health professional.
                Support groups—whether in-person or online—can be a source of empathy and shared experiences.
                Many BFS patients find it comforting to discuss their journey with others who truly understand.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ManagingStress;
